module.exports = __webpack_public_path__ + "first-100_signature.jpg?f2c19fc0ab12523d9a02778326e49729";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-100_signature.jpg
// module id = 435
// module chunks = 0